import React, { PropsWithChildren } from 'react';
import { Row } from '../contexts/row.context';
import { useStrip } from '../hooks/useStrip';
import { StripContent } from './StripContent';

export const CalibrationContainer: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { height } = useStrip();

  return (
    <Row height={height}>
      <StripContent>{children}</StripContent>
    </Row>
  );
};
